<span class="btn-label" title="Estado de transmision" data-bs-toggle="tooltip" data-bs-placement="top">
  <i class="fas fa-desktop ag-grid-header-icon"></i>
</span>

<!-- <i class="fas fa-broadcast-tower" style="color:#444444"></i> -->
	<!-- fas fa-desktop -->
